import { useEffect } from "react";

/**
 * Reliable body scroll lock for iOS Safari and in-app browsers
 * (Instagram/Facebook WebView), where `overflow: hidden` on body is ignored
 * and rubber-band scrolling makes `position: fixed` dialogs visually drift.
 *
 * Reference-counted so nested dialogs never release the lock too early.
 */
let lockCount = 0;
let savedScrollY = 0;

function applyLock() {
  const body = document.body;
  savedScrollY = window.scrollY || window.pageYOffset || 0;
  // Radix задаёт position: relative !important; блокировка iOS должна быть сильнее.
  body.style.setProperty("position", "fixed", "important");
  body.style.top = `-${savedScrollY}px`;
  body.style.left = "0";
  body.style.right = "0";
  body.style.width = "100%";
  body.style.overflow = "hidden";
}

function releaseLock() {
  const body = document.body;
  body.style.position = "";
  body.style.top = "";
  body.style.left = "";
  body.style.right = "";
  body.style.width = "";
  body.style.overflow = "";
  // vaul (Drawer) может оставить inline transform на <body>; любой transform на
  // предке ломает position: fixed у нижнего меню — страхуемся и сбрасываем.
  body.style.transform = "";
  // Не наследуем scroll-behavior: smooth: восстановление должно быть мгновенным.
  window.scrollTo({ top: savedScrollY, left: 0, behavior: "instant" });
}

export function isBodyScrollLocked() {
  return lockCount > 0;
}

export function useBodyScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;
    if (typeof document === "undefined") return;

    lockCount += 1;
    if (lockCount === 1) applyLock();

    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) releaseLock();
    };
  }, [active]);
}
